// Controls
import { Pivot, PivotItem } from "@fluentui/react";
// Styles
import { getPillPivotStyles, pivotLinkWrapperDivStyles } from "./PillPivot.styles";
// Utilities
import React, { useCallback } from "react";
/**
 * Pill pivot component. This a pivot that contains pivotItems that are rendered as pills.
 */ export function PillPivot({ pivotItemsProps, pivotProps, onPivotItemSelected }) {
    /**
     * Callback for when a pivot item is clicked
     * @param item Pivot item that was clicked
     * @param ev Event that triggered the click
     */ const onPivotItemClick = useCallback((item, ev)=>{
        if (item?.props?.itemKey != null) {
            const pivotKey = item.props.itemKey;
            onPivotItemSelected(pivotKey);
        }
    }, [
        onPivotItemSelected
    ]);
    /**
     * Custom renderer for the pivot item
     * @param pivotItemProps The props for the pivot item
     * @param defaultRenderer The fluentui default renderer for the pivot item
     */ const customRenderer = (pivotItemProps, defaultRenderer)=>{
        if (!pivotItemProps || !defaultRenderer) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            style: pivotLinkWrapperDivStyles,
            id: pivotItemProps.pivotElementId
        }, defaultRenderer(pivotItemProps));
    };
    return pivotItemsProps.length > 0 ? /*#__PURE__*/ React.createElement(Pivot, {
        ...pivotProps,
        onLinkClick: onPivotItemClick,
        styles: getPillPivotStyles
    }, pivotItemsProps.map((props)=>{
        return /*#__PURE__*/ React.createElement(PivotItem, {
            ...props,
            key: props.itemKey,
            onRenderItemLink: customRenderer
        });
    })) : null;
}
